import { fetch } from '@/api/mock/mockApiUtils';
import renovasjonsbeholderAdresse1 from './renovasjonsbeholdere/maridalsveien.json';
import renovasjonsbeholderAdresse2 from './renovasjonsbeholdere/krakebakken.json';
import updateAbonnementPapiravfallData from './updateAbonnementPapiravfallData.json';
import abonnementRestavfall from './abonnementsTjenester/restavfall.json';
import abonnementPapiravfall from './abonnementsTjenester/papiravfall.json';
import abonnementHageavfall from './abonnementsTjenester/hageavfall.json';
import abonnementMatavfall from './abonnementsTjenester/matavfall.json';
import abonnementGlassinnsamling from './abonnementsTjenester/glassinnsamling.json';

export default {
  getRenovasjonsbeholdere(postadresse) {
    if (postadresse.gate.toLowerCase() === 'maridalsveien') {
      return fetch(renovasjonsbeholderAdresse1);
    }
    return fetch(renovasjonsbeholderAdresse2);
  },
  updateAbonnement() {
    return fetch(updateAbonnementPapiravfallData);
  },
  stopAbonnement() {
    return fetch({});
  },
  getAvfallAbonnement(identifikator, ab) {
    if (ab.abonnementstypeId === 'restavfall') {
      return fetch(abonnementRestavfall);
    }
    if (ab.abonnementstypeId === 'papiravfall') {
      return fetch(abonnementPapiravfall);
    }
    if (ab.abonnementstypeId === 'hageavfall') {
      return fetch(abonnementHageavfall);
    }
    if (ab.abonnementstypeId === 'matavfall') {
      return fetch(abonnementMatavfall);
    }
    return fetch(abonnementGlassinnsamling);
  },
};
